import React, { useCallback, useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import Sidebar from "./Sidebar";
import { getPopoverByName } from "../../../utils";
import { selectSubTab } from "../../../store/common/uiSlice";
import { CanvasContext } from "../../editor/CanvasContext";
import { addText } from "../../../canvasUtils";
import { useSelector } from "react-redux";

const AvatarPopover = () => {
  const dispatch = useDispatch();
  const { canvas } = useContext(CanvasContext);
  const trial = useSelector((state) => state?.user?.details?.data?.trial);

  const thisPopover = getPopoverByName("Text", trial);

  const onTabSelect = useCallback(
    (tabIndex) => {
      dispatch(selectSubTab(tabIndex));
    },
    [dispatch]
  );

  useEffect(() => {
    // Call onTabSelect with 0 when the component mounts
    onTabSelect(0);
  }, [onTabSelect]);

  const handleClick = (object) => {
    return addText(canvas, object, dispatch);
  };

  return (
    <div className="flex w-full h-full">
      <Sidebar
        titleIcon={"/tool/dashboard/static/images/icons/tools/avatars.svg"}
        title={"Text"}
        tabs={thisPopover.tabs}
        onTabSelect={onTabSelect}
      />
      <div className="px-2 py-4 pt-8 w-4/5 bg-gray-100 flex space-x-4 justify-center">
        <button
          className="border-2 border-gray-300 text-black font-bold bg-white hover:bg-gray-100 px-6 py-2 rounded-lg shadow h-12"
          onClick={() =>
            handleClick({
              text: "Title",
              fontWeight: "800",
              fontSize: "40",
            })
          }
        >
          Add Title
        </button>
        <button
          className="border-2 border-gray-300 text-black bg-white hover:bg-gray-100 px-6 py-2 rounded-lg shadow h-12"
          onClick={() =>
            handleClick({
              text: "Subtitle",
              fontWeight: "400",
              fontSize: "30",
            })
          }
        >
          Add Subtitle
        </button>
        <button
          className="border-2 border-gray-300 text-gray-800 text-sm font-thin bg-white hover:bg-gray-100 px-6 py-2 rounded-lg shadow h-12"
          onClick={() =>
            handleClick({
              text: "body text",
              fontWeight: "300",
              fontSize: "20",
            })
          }
        >
          Add Body Text
        </button>
      </div>
    </div>
  );
};

export default AvatarPopover;
